import { GameSettingsStore } from "./GameSettingsStore.js";
import { LocalizationStore } from "./LocalizationStore.js";

export class RootStore {
  constructor() {
    this.settingsStore = new GameSettingsStore(this);
    this.localizationStore = new LocalizationStore(this);
  }
}

export const rootStore = new RootStore();

